import type { ImageProps } from 'next/image';
import Image from 'next/image';
import { cn } from '@/utils/cn';

const GM_STATUS_IMAGE_SIZE = {
  small: 48,
  large: 250,
} as const;

interface GmStatusImageProps extends Omit<ImageProps, 'width' | 'height'> {
  variant?: keyof typeof GM_STATUS_IMAGE_SIZE;
}

export const GmStatusImage = ({
  className,
  variant = 'small',
  ...imageProps
}: GmStatusImageProps) => {
  const size = GM_STATUS_IMAGE_SIZE[variant];

  return (
    <Image
      {...imageProps}
      width={size}
      height={size}
      draggable={false}
      className={cn('shrink-0 object-contain', className)}
    />
  );
};
